import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { RestService } from 'src/app/services/rest.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-file-parser',
  templateUrl: './file-parser.component.html',
  styleUrls: ['./file-parser.component.css'],
})
export class FileParserComponent implements OnInit {
  @Input() title: any = 'File selection';
  @Input() path: string = '/api/files/parse';
  @Input() submitButtonText: string = 'Submit';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() templateFileUrl: string;
  @Input() absoluteUrl: boolean = false;
  @Output() parsedData: EventEmitter<any[]> = new EventEmitter();
  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();

  parseResponse: any = {};
  parsedSelectedData: any;
  properties: any = {
    label: 'Browse file',
    filePreview: true,
  };
  fileWithFormData: FormData;
  fileToUpload: File = null;
  isUploading = false;
  form: FormGroup;
  isSubmitted: boolean;
  errorMessage: string;

  constructor(private restService: RestService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  get f() {
    return this.form.controls;
  }

  buildForm() {
    this.form = this.fb.group({
      sheet: ['', [Validators.required]],
    });
  }

  handleFileInput(file) {
    this.errorMessage = undefined;
    var files: FileList = file;
    this.fileToUpload = files.item(0);
    // tslint:disable-next-line:max-line-length
    const regex = new RegExp(
      '(.*?)(application/vnd.ms-excel|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet|text/csv)$',
    );
    if (!regex.test(this.fileToUpload.type)) {
      this.errorMessage = `Please select correct file format`;
      return;
    }
    this.isUploading = true;
    this.fileWithFormData = new FormData();
    this.fileWithFormData.append('file', this.fileToUpload, this.fileToUpload.name);
    this.fileWithFormData.append('path', 'files');
    this.restService.postFile(`${this.path}`, this.fileWithFormData, this.absoluteUrl).subscribe(
      data => {
        this.parseResponse = data;
        this.isUploading = false;
      },
      error => {
        this.isUploading = false;
        this.errorMessage = error;
      },
    );
  }

  onSheetSelect(event: any) {
    this.parsedSelectedData = _.find(
      this.parseResponse.parsedData,
      (data: any) => data.sheetName.toString() === event.target.value.toString(),
    );
  }

  cancel() {
    this.onCancel.emit(true);
  }

  onSubmit() {
    this.isSubmitted = true;
    if (
      !this.parseResponse.parsedData ||
      (this.form.invalid &&
        this.parseResponse.parsedData &&
        this.parseResponse.parsedData.length > 1)
    ) {
      return;
    }
    this.parsedSelectedData =
      this.parsedSelectedData ||
      (this.parseResponse && this.parseResponse.parsedData && this.parseResponse.parsedData[0]);
    this.parsedData.emit(this.parsedSelectedData.data);
  }
}
